module.exports = __webpack_public_path__ + "img/home_banner_1.c0900f00.png";